import type { SVGProps } from 'react';
const SvgIconDevelopers = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8 9.75A.75.75 0 0 1 8.75 9h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 9.75m-3.78-.535a.75.75 0 0 0 1.06 1.06l1.768-1.767a.75.75 0 0 0 0-1.06L5.28 5.68a.75.75 0 0 0-1.06 1.06l.99 1.238z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5 2h9A2.5 2.5 0 0 1 15 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-7A2.5 2.5 0 0 1 3.5 2m0 1.5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDevelopers;
